'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.optionType = optionType;
exports.colorOption = colorOption;
exports.sizeOption = sizeOption;
exports.hasHexRef = hasHexRef;
exports.hexRef = hexRef;
exports.imageUrl = imageUrl;

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function optionType(variant, name) {
  if ((0, _keys2.default)(variant).indexOf('optionValues') === -1) {
    return null;
  }

  return (0, _lodash.filter)(variant.optionValues, function (ov) {
    return ov.optionTypeName.endsWith(name);
  });
}

function colorOption(variant) {
  return (0, _lodash.first)(optionType(variant, 'Color')) || {};
}

function sizeOption(variant) {
  return (0, _lodash.first)(optionType(variant, 'Size')) || {};
}

function hasHexRef(variant) {
  if ((0, _keys2.default)(variant).indexOf('colorHex') === -1) return false;
  if (variant.colorHex === '') return false;
  if (!variant.colorHex) return false;

  return true;
}

function hexRef(variant) {
  if (!hasHexRef(variant)) return '';

  return '#' + variant.colorHex;
}

function imageUrl(variant) {
  if (!variant.displayImage) {
    return '';
  }

  return variant.displayImage;
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/lineItem.js
// module id = 244
// module chunks = 0